import { UserProps } from '@contexts/session'

export const FLAGGED_FEATURES = {
  GAMIFICATION: {
    users: ['student@codingal.com', 'student1@codingal.com'],
    flag: 'gamification',
  },
  COURSE_MODULES: {
    users: ['student@codingal.com', 'student1@codingal.com'],
    flag: 'course-modules',
  },
  QUIZ_COMPETITION: {
    emailDomain: '@codingal.com',
    flag: 'quiz-competition',
  },
  STUDENT_CERTIFICATE: {
    users: ['bakareroheet@gmail.com'],
    flag: 'student-certificate',
  },
  STUDENT_LEADERBOARD: 'student-leaderboard',
  TEACHER_LEADERBOARD: 'teacher-leaderboard',
  STUDENT_RANK: 'student-rank',
  TEACHER_RANK: 'teacher-rank',
  STUDENT_POINTS_LOG: 'student-points-log',
  TEACHER_POINTS_LOG: 'teacher-points-log',
  ENABLE_STAR_TEACHER: 'enable-star-teacher', // Feature flag to enable/disable star teacher functionality
  TEACHER_PREP_BRIEF: 'teacher-prep-brief', // Feature flag to enable/disable smart class prep brief
  AI_CODING_TUTOR: 'ai-coding-tutor',
  TEACHER_REFUND_LOG: 'teacher-refund-log', // Feature flag to enable/disable the dashboard refund log
}

export const getFeaturesForUser = (userData: UserProps) => {
  const features = []
  const { loggedIn, student, teacher } = userData

  if (loggedIn) {
    // Object.keys(FLAGGED_FEATURES).forEach((feature) => {
    //   if (FLAGGED_FEATURES[feature]?.users?.includes(email)) {
    //     features.push(FLAGGED_FEATURES[feature].flag)
    //   }
    // })

    features.push(FLAGGED_FEATURES.GAMIFICATION.flag)
    features.push(FLAGGED_FEATURES.COURSE_MODULES.flag)
    features.push(FLAGGED_FEATURES.STUDENT_CERTIFICATE.flag)

    // Only enable student features for students
    if (student) {
      features.push(FLAGGED_FEATURES.STUDENT_LEADERBOARD)
      features.push(FLAGGED_FEATURES.STUDENT_RANK)
      features.push(FLAGGED_FEATURES.STUDENT_POINTS_LOG)
      features.push(FLAGGED_FEATURES.AI_CODING_TUTOR)
    }

    // Enable teacher features
    if (teacher) {
      features.push(FLAGGED_FEATURES.TEACHER_LEADERBOARD)
      features.push(FLAGGED_FEATURES.TEACHER_RANK)
      features.push(FLAGGED_FEATURES.TEACHER_POINTS_LOG)
      features.push(FLAGGED_FEATURES.TEACHER_PREP_BRIEF)

      // ENABLE_STAR_TEACHER feature flag is set to false by default
      // Uncomment the next line to enable the feature
      // features.push(FLAGGED_FEATURES.ENABLE_STAR_TEACHER)

      // Back on since the refund teacher attribution backfill ran: every row
      // now names the teacher who actually taught the student, and a refund
      // paid out in parts counts once.
      features.push(FLAGGED_FEATURES.TEACHER_REFUND_LOG)
    }
  }
  features.push(FLAGGED_FEATURES.QUIZ_COMPETITION.flag)
  return features
}

export const isFastCommentsEnabled = () => false

// Feature flag to show the Trustpilot rating (TrustBox widgets, rating text and
// the Trustpilot script) on all pages. Flip to false to hide it.
export const isTrustpilotRatingEnabled = () => true

// Mixpanel sends events only from production builds. Flip this to true on your
// machine to also send (and log to the console) from a dev build while testing
// the student trial funnel. Keep it false in commits.
export const isMixpanelDebugEnabled = () => false
